const RECIPE_FALLBACK = '/assets/icons/Recipe.svg'

function isHttp(value?: string | null): value is string {
  return !!value && value.startsWith('http')
}

/** New 800px card derivatives live at recipe/{id}/card/... — not leftover thumbnail_path files. */
export function isRecipeCardDerivative(url: string): boolean {
  const path = url.split('?')[0]
  return path.includes('/card/')
}

type RecipeCardImageFields = {
  resourcePath?: string | null
  thumbnailPath?: string | null
  recipe_img_url?: string | null
  recipe_image?: {
    resource_path?: string | null
    thumbnail_path?: string | null
  } | null
}

export function recipeCardSrc(recipe: RecipeCardImageFields): string {
  const cardThumbs = [recipe.thumbnailPath, recipe.recipe_image?.thumbnail_path]
  for (const thumb of cardThumbs) {
    if (isHttp(thumb) && isRecipeCardDerivative(thumb)) return thumb
  }
  if (isHttp(recipe.resourcePath)) return recipe.resourcePath
  if (isHttp(recipe.recipe_image?.resource_path)) return recipe.recipe_image.resource_path
  if (isHttp(recipe.recipe_img_url)) return recipe.recipe_img_url
  return RECIPE_FALLBACK
}
